import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { ADORNMENT_POSITION } from './constants.js';
import { InputAdornmentWrapper } from './styledComponents.js';

var InputAdornment = function InputAdornment(_ref) {
  var adornment = _ref.adornment,
      hasIcon = _ref.hasIcon,
      position = _ref.position,
      variant = _ref.variant,
      customStyle = _ref.customStyle;

  var _safeCustomStyle = safeCustomStyle(customStyle),
      adornmentStyle = _safeCustomStyle.adornmentStyle;

  return /*#__PURE__*/React.createElement(InputAdornmentWrapper, {
    className: "adornment-style",
    hasIcon: hasIcon,
    position: position,
    variant: variant,
    "aria-hidden": true,
    adornmentStyle: adornmentStyle
  }, adornment);
};

process.env.NODE_ENV !== "production" ? InputAdornment.propTypes = {
  /** DOM element ID of text input */
  adornment: PropTypes.string.isRequired,

  /** Datalist content array */
  position: PropTypes.oneOf([ADORNMENT_POSITION.LEFT, ADORNMENT_POSITION.RIGHT]),
  customStyle: PropTypes.shape({
    adornmentStyle: PropTypes.object
  })
} : void 0;
InputAdornment.defaultProps = {
  position: ADORNMENT_POSITION.LEFT,
  customStyle: {
    adornmentStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? InputAdornment.displayName = 'InputAdornment' : void 0;
var InputAdornment$1 = InputAdornment;

export { InputAdornment$1 as default };
